import React from "react";
import { Button, Accordion, Spinner } from "react-bootstrap";
import Plus from "Components/Icons/Plus";
import Minus from "Components/Icons/Minus";
import { CustomSelect } from "Components/Common/CustomSelect";
import { PlusCircle } from "Components/Icons/PlusCircle";
import { MinusCircleIcon } from "Components/Icons/MinusCircleIcon";
import { DomainCompetency } from "Stores/courseStore";
import { useCategorySelection } from "./hook";
import { useCompetencyMatchingContext } from "@/contexts/competencyMatchingContext";

export const CategorySelection = () => {
    const {
        activeKeys,
        expandedItems,
        // NOTE: Dima requested that it be removed for now. Since it will be enabled in the future, I kept the code but commented it out.
        // matchResults,
        standardsCategoriesLoading,
        categoriesLoading,
        selectedStandardCategoryData,
        handleAccordionToggle,
        handleCategoryChange,
        addCategory,
        removeCategory,
        getSelectedCategories,
        getSiblingOptions,
    } = useCategorySelection();

    const { handleNextStep, handlePreviousStep } =
        useCompetencyMatchingContext();

    const renderMatchLevels = () => (
        // NOTE: Dima requested that it be removed for now. Since it will be enabled in the future, I kept the code but commented it out.
        <div className="match-levels mb-4">
            {/* //     <span className="levels-label me-3">Levels of match:</span>
        //     <div className="d-inline-flex align-items-center gap-4">
        //         <div className="d-flex align-items-center gap-2">
        //             <MatchIndicator matchLevel="high" />
        //             <span>High</span>
        //         </div>
        //         <div className="d-flex align-items-center gap-2">
        //             <MatchIndicator matchLevel="mid" />
        //             <span>Mid</span>
        //         </div>
        //         <div className="d-flex align-items-center gap-2">
        //             <MatchIndicator matchLevel="low" />
        //             <span>Low</span>
        //         </div>
        //         <div className="d-flex align-items-center gap-2">
        //             <CircleInfoIcon />
        //             <span>No match</span>
        //         </div>
        //         <div className="d-flex align-items-center gap-2">
        //             <PersonIcon />
        //             <span>Manual</span>
        //         </div>
        //     </div> */}
        </div>
    );

    const renderCompetencyItem = (item: DomainCompetency, level = 0) => {
        const hasChildren = item.children.length > 0;
        const isOpen = activeKeys.includes(item.ruuid);
        const itemCategories = getSelectedCategories(item.ruuid);
        const shouldRenderChildren = expandedItems[item.ruuid];
        const siblingOptions = getSiblingOptions(item);

        return (
            <div key={item.ruuid} className="competency-item">
                <div
                    className="competency-item-inner"
                    style={{ paddingLeft: `${level * 20}px` }}
                >
                    <Accordion.Item eventKey={item.ruuid} className="border-0">
                        <div className="d-flex align-items-center competency-header py-2">
                            {hasChildren ? (
                                <Button
                                    variant="link"
                                    onClick={() =>
                                        handleAccordionToggle(item.ruuid)
                                    }
                                    className="p-0 me-3 toggle-button"
                                >
                                    {isOpen ? <Minus /> : <Plus />}
                                </Button>
                            ) : (
                                <span
                                    className="toggle-placeholder me-2"
                                    style={{
                                        width: "16px",
                                        display: "inline-block",
                                    }}
                                ></span>
                            )}
                            <div className="competency-content d-flex align-items-center">
                                <div>{item.standard_name}</div>
                                <div className="d-flex flex-column gap-2">
                                    {itemCategories.map((category, index) => {
                                        // NOTE: Dima requested that it be removed for now. Since it will be enabled in the future, I kept the code but commented it out.
                                        // const matchResult = matchResults[
                                        //     item.ruuid
                                        // ]?.[index.toString()] || {
                                        //     matchLevel: "manual",
                                        //     matchPercentage: 0,
                                        // };
                                        return (
                                            <div
                                                key={index}
                                                className="d-flex align-items-center gap-2"
                                            >
                                                <CustomSelect
                                                    options={siblingOptions}
                                                    value={siblingOptions.find(
                                                        (option) =>
                                                            option.value ===
                                                            category
                                                    )}
                                                    onChange={(value) =>
                                                        handleCategoryChange(
                                                            item.ruuid,
                                                            index,
                                                            value
                                                        )
                                                    }
                                                    isDisabled={
                                                        categoriesLoading
                                                    }
                                                    placeholder="Select an option"
                                                    className="category-select"
                                                />
                                                {index > 0 ? (
                                                    <Button
                                                        variant="link"
                                                        className="p-0"
                                                        onClick={() =>
                                                            removeCategory(
                                                                item.ruuid,
                                                                index
                                                            )
                                                        }
                                                    >
                                                        <MinusCircleIcon
                                                            size={16}
                                                            className="toggle-icon"
                                                            color="#b0b0b0"
                                                        />
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        variant="link"
                                                        className="p-0"
                                                        onClick={() =>
                                                            addCategory(
                                                                item.ruuid
                                                            )
                                                        }
                                                    >
                                                        <PlusCircle
                                                            size={16}
                                                            className="toggle-icon"
                                                            color="#b0b0b0"
                                                        />
                                                    </Button>
                                                )}
                                                {/*
                                                NOTE: Dima requested that it be removed for now. Since it will be enabled in the future, I kept the code but commented it out.
                                                <div
                                                    className="match-indicator d-flex align-items-center justify-content-center"
                                                    style={{ height: "32px" }}
                                                >
                                                    <MatchIndicator
                                                        matchLevel={
                                                            matchResult.matchLevel
                                                        }
                                                        size={16}
                                                    />
                                                </div> */}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        {hasChildren && (
                            <Accordion.Collapse eventKey={item.ruuid}>
                                <div className="competency-children">
                                    {shouldRenderChildren &&
                                        item.children.map((child) =>
                                            renderCompetencyItem(
                                                child,
                                                level + 1
                                            )
                                        )}
                                </div>
                            </Accordion.Collapse>
                        )}
                    </Accordion.Item>
                </div>
            </div>
        );
    };

    return (
        <div className="w-100">
            <label className="section-title mb-4">Select the categories</label>
            {renderMatchLevels()}
            <div className="competency-list">
                <div className="competency-header-row py-2 px-3">
                    <div className="row w-100">
                        <div className="col-8">Standard Competency</div>
                        <div className="col-4 text-center">Your Competency</div>
                        {/* NOTE: Dima requested that it be removed for now. Since it will be enabled in the future, I kept the code but commented it out. */}
                        {/* <div className="col-1 text-center">Match</div> */}
                    </div>
                </div>
                {standardsCategoriesLoading ? (
                    <div className="d-flex justify-content-center py-4">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <Accordion
                        activeKey={activeKeys}
                        className="competency-accordion"
                    >
                        {selectedStandardCategoryData &&
                            renderCompetencyItem(selectedStandardCategoryData)}
                    </Accordion>
                )}
            </div>
            <div className="form-actions form-actions--matching mt-4">
                <Button
                    variant="outline-secondary"
                    onClick={handlePreviousStep}
                >
                    Back
                </Button>
                <Button
                    variant="primary"
                    className="btn-continue"
                    onClick={handleNextStep}
                >
                    Continue
                </Button>
            </div>
        </div>
    );
};
